import React, { useState } from "react";
import { useFormik } from "formik";
import google from "../Assets/imgs/google.webp";
interface SignUpData {
  name: string;
  address: string;
  companyName: string;
  password: string;
  confirmPassword: string;
  number: string;
  vatNumber: string;
}
interface SignUpProps {
  onSignUpPressed: (signupData: SignUpData) => void;
  isIos: boolean;
}

const passwordGuideline =
  "Password must be 8-40 characters, include at least one uppercase letter, one lowercase letter, and one number.";

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,40}$/;

const validate = (values: {
  name: string;
  address: string;
  companyName: string;
  password: string;
  confirmPassword: string;
  number: string;
  vatNumber: string;
}) => {
  const errors: {
    name?: string;
    address?: string;
    companyName?: string;
    password?: string;
    confirmPassword?: string;
    number?: string;
    vatNumber?: string;
  } = {};
  if (!values.name) {
    errors.name = "Name is required";
  } else if (/^\s/.test(values.name)) {
    errors.name = "Name cannot start with a space";
  }
  if (!values.address) {
    errors.address = "Address is required";
  } else if (/^\s/.test(values.address)) {
    errors.address = "Address cannot start with a space";
  }
  if (!values.number) {
    errors.number = "Number is required";
  } else if (!/^\+?\d+$/.test(values.number)) {
    errors.number = "Only digits are allowed, optionally starting with '+'";
  } else if (values.number.replace(/^\+/, "").length > 12) {
    errors.number = "Number must be at most 12 digits (excluding '+')";
  }
  if (!values.vatNumber) {
    errors.vatNumber = "VatNumber is required";
  } else if (/^\s/.test(values.vatNumber)) {
    errors.vatNumber = "VatNumber cannot start with a space";
  }
  if (!values.companyName) {
    errors.companyName = "Company name is required";
  } else if (/^\s/.test(values.companyName)) {
    errors.companyName = "Company name cannot start with a space";
  }
  if (!values.password) {
    errors.password = "Password is required";
  } else if (!passwordRegex.test(values.password)) {
    errors.password = passwordGuideline;
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = "Confirm password is required";
  } else if (values.password !== values.confirmPassword) {
    errors.confirmPassword = "Passwords do not match";
  }
  return errors;
};

const SignUp: React.FC<SignUpProps> = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [termsError, setTermsError] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const formik = useFormik({
    initialValues: {
      name: "",
      address: "",
      companyName: "",
      password: "",
      confirmPassword: "",
      number: "",
      vatNumber: "",
    },
    validate,
    onSubmit: (values) => {
      // Handle sign up logic here
      if (!isChecked) {
        setTermsError("You must agree to the Terms of Use");
        return;
      } else {
        setTermsError(""); // clear error if previously shown
        props.onSignUpPressed(values);
      }
    },
  });
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
  };
  return (
    <div className="__login signup">
      <div className="login-Wraper">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="__form">
                <div className="heading">SIGN UP</div>
                <div className="loginaccount">Create your account</div>
                <div className="blue__line"></div>
                <form onSubmit={formik.handleSubmit}>
                  <div className="input_flex">
                    <div className="inputField">
                      <label htmlFor="name">Name</label>
                      <input
                        id="name"
                        name="name"
                        type="text"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.name && formik.errors.name ? (
                        <div className="error">{formik.errors.name}</div>
                      ) : null}
                    </div>
                    <div className="inputField">
                      <label htmlFor="companyName">Company Name</label>
                      <input
                        id="companyName"
                        name="companyName"
                        type="text"
                        value={formik.values.companyName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.companyName &&
                      formik.errors.companyName ? (
                        <div className="error">{formik.errors.companyName}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="input_flex">
                    <div className="inputField">
                      <label htmlFor="password">Password</label>
                      <div className="passwordParent">
                        <input
                          id="password"
                          name="password"
                          type={showPassword ? "text" : "password"}
                          value={formik.values.password}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        <div
                          className="watchPassword"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{
                            right: 10,
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            listStyle: "none",
                            color: "#888",
                            fontSize: "20px",
                          }}
                        >
                          <i
                            className={
                              showPassword ? "ri-eye-off-line" : "ri-eye-line"
                            }
                          ></i>
                        </div>
                      </div>
                      {formik.touched.password && formik.errors.password ? (
                        <div className="error">{formik.errors.password}</div>
                      ) : null}
                    </div>
                    <div className="inputField">
                      <label htmlFor="confirmPassword">Confirm Password</label>
                      <div className="passwordParent">
                        <input
                          id="confirmPassword"
                          name="confirmPassword"
                          type={showConfirmPassword ? "text" : "password"}
                          value={formik.values.confirmPassword}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        <div
                          className="watchPassword"
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        >
                          <i
                            className={
                              showConfirmPassword
                                ? "ri-eye-off-line"
                                : "ri-eye-line"
                            }
                          ></i>
                        </div>
                      </div>
                      {formik.touched.confirmPassword &&
                      formik.errors.confirmPassword ? (
                        <div className="error">
                          {formik.errors.confirmPassword}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="input_flex">
                    <div className="inputField">
                      <label htmlFor="number">Phone Number</label>
                      <input
                        id="number"
                        name="number"
                        type="text"
                        value={formik.values.number}
                        onChange={(e) => {
                          let value = e.target.value;

                          // Allow only one leading +
                          if (value.startsWith("+")) {
                            value = "+" + value.slice(1).replace(/\D/g, "");
                          } else {
                            value = value.replace(/\D/g, "");
                          }

                          formik.setFieldValue("number", value);
                        }}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.number && formik.errors.number ? (
                        <div className="error">{formik.errors.number}</div>
                      ) : null}
                    </div>
                    <div className="inputField">
                      <label htmlFor="vatNumber">VAT Number</label>
                      <input
                        id="vatNumber"
                        name="vatNumber"
                        type="text"
                        value={formik.values.vatNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.vatNumber && formik.errors.vatNumber ? (
                        <div className="error">{formik.errors.vatNumber}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="inputField">
                    <label htmlFor="address">Address</label>
                    <input
                      id="address"
                      name="address"
                      type="text"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.address && formik.errors.address ? (
                      <div className="error">{formik.errors.address}</div>
                    ) : null}
                  </div>

                  <div className="login_btn">
                    <button type="submit">Sign Up</button>
                  </div>
                </form>
                {!props.isIos && (
                  <>
                    {" "}
                    <div className="OR">
                      <span className="loginwith">OR Log in with</span>
                    </div>
                    <div className="loginGoogle">
                      <button>
                        <span>
                          <img
                            src={google}
                            alt="google"
                            className="googleImg"
                          />
                        </span>
                        Log in with google
                      </button>
                    </div>
                    <div className="dontAccount">
                      Already have an account? <a href="Login">Log in</a>{" "}
                    </div>
                  </>
                )}

                <div
                  className="flex-gap termsAndCondtion"
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <label
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={(e) => {
                        setIsChecked(e.target.checked);
                        if (e.target.checked) setTermsError("");
                      }}
                    />
                    <span>
                      By signing in you agree to the{" "}
                      <a href="/terms" className="tandc">
                        Terms of Use
                      </a>
                    </span>
                  </label>

                  {termsError && <div className="error">{termsError}</div>}
                  <div className="policyText">
                    <span>*</span> Enjoy a 7-day free trial. After that, a
                    €50/month license fee applies, plus €1 per completed
                    checklist. <span>*</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mobileBG">
              <div className="loginRightSide">
                <div className="welconeText">WELCOME TO </div>
                <div className="myCheckList">QualiCheck</div>
                <div className="loginDesc">
                  Your digital checklist and operational-assurance
                  platform—structured, traceable and ready to support your
                  operations.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
